export default {
  MAX_PACKED_TRIFOLD: 160,
};
